import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useSearchInputContext } from 'src/common/components/Search/SearchInputProvider';
import CapacityFilter from 'src/common/components/CapacityFilter';
import Typography from 'src/common/components/Typography';
import styles from './SheetGuests.module.scss';

const SheetGuests: FC = () => {
  const [t] = useTranslation('common');
  const { filterGuests, setFilterGuests } = useSearchInputContext();

  return (
    <div
      aria-label={t('search--search-who-title')}
      className={styles.root}
    >
      <Typography
        size="body-xl"
        weight="semibold"
        type="h3"
      >
        {t('search--search-who-title')}
      </Typography>
      <CapacityFilter
        value={filterGuests}
        onChange={setFilterGuests}
        classNameModifier="guestFilter"
      />
    </div>
  );
};

export default SheetGuests;
